import Profile from './';
export default [
  {
    type: 'private',
    path: '/profile',
    component: Profile,
    exact: true,
    private: true
  }
];



// WEBPACK FOOTER //
// ./src/views/profile/_routes.js